import { VpIcon } from '@vtmn-play/react';
import { useTranslation } from 'react-i18next';

import { SpoSmSheetResponse } from '@spo/types';
import { useCharacteristicProfile } from '../../hooks/useCharacteristicProfile';
import { useRetailFamilyById } from '../../hooks/useRetailFamily';
import { useSportsByIds } from '../../hooks/useSports';
import { capitalizeString } from '../../utils/text-display';
import { SmInfoContainer } from '../SmInfoContainer';
import { SmInfoDisplay } from '../smInfoDisplay';

export interface SmSportProps {
  sm: SpoSmSheetResponse | undefined;
  isLoading: boolean;
}

export const SmSport = ({ sm, isLoading }: SmSportProps) => {
  const { t } = useTranslation();
  const params = new URLSearchParams(document.location.search);
  const offerDate = params.get('offerDate');

  const { data: sportData, isFetching: isSportFetching } = useSportsByIds(
    sm?.sportId ? [sm?.sportId] : [],
  );
  const { data: retailFamilyData, isFetching: isRetailFamilyFetching } =
    useRetailFamilyById(Number(sm?.retailFamilyId), offerDate || '');

  const { data: characteristicData, isFetching: isCharacteristicFetching } =
    useCharacteristicProfile(
      sm?.id || '',
      sm?.characteristicProfile || '',
      sm?.productNatureId.toString() || '',
    );

  return (
    <SmInfoContainer
      title={t('sm-info.sport')}
      icon={<VpIcon name="t-shirt-number" />}
    >
      <div className="sm-info-main-line">
        <SmInfoDisplay label={t('sm-info.sport')} isLoading={isSportFetching}>
          {sportData ? `${sm?.sportId} - ${sportData[0].name}` : sm?.sportId}
        </SmInfoDisplay>
        <SmInfoDisplay label={t('sm-info.brand')} isLoading={isLoading}>
          {sm?.brandLabel ?? sm?.brandId}
        </SmInfoDisplay>
      </div>
      <div className="sm-info-main-line">
        <SmInfoDisplay
          label={t('sm-info.product-nature')}
          isLoading={isLoading}
        >
          {sm?.productNatureLabel
            ? `${sm?.productNatureId} - ${capitalizeString(sm.productNatureLabel)}`
            : sm?.productNatureId}
        </SmInfoDisplay>
        <SmInfoDisplay
          label={t('sm-info.retail-family')}
          isLoading={isRetailFamilyFetching}
        >
          {retailFamilyData
            ? `${sm?.retailFamilyId} - ${retailFamilyData[0].name}`
            : sm?.retailFamilyId}
        </SmInfoDisplay>
      </div>
      <SmInfoDisplay
        label={t('sm-info.characteristic-profile')}
        isLoading={isCharacteristicFetching}
      >
        {`${sm?.characteristicProfile} - ${characteristicData?.name}`}
      </SmInfoDisplay>
    </SmInfoContainer>
  );
};
